import React, {useContext, useState} from "react";
import ErrorBoundary from "../ui-components/ErrorBoundary";
import { useIntl, FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { PageHeading } from "@ui-components/Container";
import { HomeIcon } from "@heroicons/react/24/solid";
import Button from "../ui-components/Button";
import {WorksitesFiltersType} from "@feature/worksites/home/filters/types";
import {WorksitesMap} from "@feature/worksites/home/map";
import CountryContext from "../CountryContext";
import {WorksitesFilters} from "@feature/worksites/home/filters";
import {useHomeUsers} from "@feature/worksites/home/hooks/useHomeUsers";
import {WorksitesTable} from "@feature/worksites/home/table";
import {useWorksiteTypes} from "@feature/worksites/hooks/useWorksiteTypes";
import {EditWorksiteModal} from "@feature/worksites/edit-worksite-modal";


const Worksites = () => {

  // context
  const {country} = useContext(CountryContext);

  // state
  const [filters, setFilters]
    = useState<WorksitesFiltersType>({
      search: "",
      type: undefined,
      status: undefined,
      province: undefined,
      creator: undefined,
      shared_with: undefined,
      visibile_to_manager: undefined,
      visibile_to_agent: undefined,
      include_inactive: false,
      show_only_test: false,
      show_only_terminated: false,
    });
  const [showNewWorksiteDialog, setShowNewWorksiteDialog]
    = useState(false);
  const [refreshObservable, setRefreshObservable]
    = useState(false);  // Used to force refresh of map and table

  // hooks
  const intl = useIntl();
  const history = useHistory();
  const {data: users} = useHomeUsers(country.code);
  const {data: worksiteTypes} = useWorksiteTypes();

  // utils
  const goToWorksite = (worksiteId: number) => history.push(`/${country.code}/worksites/${worksiteId}`);

  return (
    <>
      <div className="flex flex-col gap-8 mb-8">
        <PageHeading
          title={intl.formatMessage({ id: "worksites" })}
          contentActions={
            <Button
              variant="contained"
              color="primary"
              onClick={() => setShowNewWorksiteDialog(true)}
            >
              <HomeIcon className="-ml-0.5 mr-1 w-4" aria-hidden="true" />
              <FormattedMessage id="add" />
            </Button>
          }
        />
        <hr className="-mt-6" />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <WorksitesMap
            filters={filters}
            onClick={goToWorksite}
            refreshObservable={refreshObservable}
          />
          <WorksitesFilters
            value={filters}
            onChange={setFilters}
            users={users}
            worksitesTypes={worksiteTypes}
          />
        </div>
        <WorksitesTable
          filters={filters}
          users={users}
          refreshObservable={refreshObservable}
        />
      </div>
      <ErrorBoundary from="worksite-add-dialog">
        {showNewWorksiteDialog && (
          <EditWorksiteModal
            onSuccess={(worksite: any) => {
              setRefreshObservable((prev) => !prev);
              setShowNewWorksiteDialog(false);
              // HOTFIX Ticket hubspot: 8903312411
              // Add worksite would not send in the new page
              goToWorksite(worksite.id);
            }}
            onClose={() => setShowNewWorksiteDialog(false)}
            worksiteTypes={worksiteTypes}
          />
        )}
      </ErrorBoundary>
    </>
  );
};

export default Worksites;